import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";
import type { renewalsReportTabs } from "../../../components/ActionReports/RenewalsActionReport/RenewalsActionReport";

export const renewalsPageViewTrack = (period: string, tab: renewalsReportTabs) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    tab,
  );
};

export const renewalsTabClickTrack = (tab: renewalsReportTabs) => {
  track(TEALIUM.U_TAG_METHOD.LINK, TEALIUM.EVENT_NAME.CLICK_ACTION, "", TEALIUM.CATEGORY.RENEWALS_AR, tab, tab);
};

export const renewalsExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.RENEWALS_AR,
    "export",
  );
};

export const renewalsProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.RENEWALS_AR,
    "profile",
  );
};

export const renewalsCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "customize_KPI",
    "customize_KPI",
  );
};

export const renewalsApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "customize_KPI",
    "apply_customize_KPI",
  );
};

export const renewalsCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "customize_KPI",
    "cancel_customize_KPI",
  );
};

export const renewalsAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.RENEWALS_AR,
    "add_to_watchlist",
  );
};

export const renewalsSelectGroupLeaderTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.RENEWALS_AR,
    "select_group_leader",
  );
};

export const renewalsSearchTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    TEALIUM.CATEGORY.RENEWALS_AR,
    "search",
  );
};

export const renewalsPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "renewals-action-report",
    "phone_icon",
  );
};

export const renewalsTreeViewTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "renewals",
    "tree_view",
  );
};

export const renewalsListViewTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "renewals",
    "list_view",
  );
};

export const renewalsMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.RENEWALS_AR,
    "renewals-action-report",
    "message_icon",
  );
};
